import { render, staticRenderFns } from "./List.vue?vue&type=template&id=e1996b26&scoped=true"
import script from "./List.vue.js?vue&type=script&lang=js&external"
export * from "./List.vue.js?vue&type=script&lang=js&external"
import style0 from "./List.vue?vue&type=style&index=0&id=e1996b26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1996b26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBreadcrumbs,VImg})
